import {defineStore} from 'pinia'
import API from '@/api'

const configStore =  defineStore('config', {
    state: () => ({
        platforms: []
    }),
    actions: {
        getPlatforms()
        {
            API.getPlatforms().then(response => {
                this.platforms = response.data
            })
        }
    }
});

export
{
    configStore
}
